// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__G235v","popup":"Modal_popup__gVj0P","centeredParent":"Modal_centeredParent__-j1sp","closeButton":"Modal_closeButton__anuVQ"};